document.addEventListener("DOMContentLoaded", function () {
    const shopByCategoryItems = document.querySelectorAll(".header-nav-item.header-nav-item--has-sub");
    [0, 4].forEach(idx => {
        const shopByCategoryCont = shopByCategoryItems[idx];
        if (shopByCategoryCont === undefined) {
            return;
        }
        shopByCategoryCont.classList.add("menu-shop-by-category");
        const categories = Array.from(shopByCategoryCont.querySelectorAll(".header-sub-nav-item a"));
        categories.forEach((category) => {
            const categoryImg = document.createElement("img");
            categoryImg.width = 40;
            categoryImg.height = 40;
            const categoryIndex = categories.indexOf(category);
            categoryImg.classList.add("category-icon");
            categoryImg.src = categoryIconMap[categoryIndex];
            categoryImg.alt = category.textContent.trim();
            category.prepend(categoryImg);
        });
    });
});